import { useMemo } from 'preact/hooks';

import { useViewportType } from './useViewportType';
import { useContainerWidth } from './useContainerWidth';

export const useSliderItemWidth = () => {
  const { isMobile } = useViewportType();
  const { containerWidth } = useContainerWidth();

  const sliderItemWidth = useMemo(() => {
    const count = isMobile ? 2.75 : 3.25;
    const padding = isMobile ? 12 : 48;

    return (containerWidth - 2 * padding) / count;
  }, [containerWidth, isMobile]);

  return { sliderItemWidth };
};
